<template>
  <div class="card-header">
    <div class="card-title">
      <slot />
    </div>
    <div class="card-action">
      <slot name="action">
        <!-- <el-link type="primary" :underline="false"
          >更多<i class="el-icon-arrow-right" style="color:#999999;"></i>
        </el-link>-->
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  // height: 30px;

  .card-title {
    font-size: 20px;
    //font-weight: bold;
    color: #333333;
    height:24px;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .card-action {
    font-size: 14px;
    flex-shrink:0;
  }
}
</style>
